import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=338435ec&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338435ec",
  null
  
)

export default component.exports